export default Object.freeze({
  MY_PROFILE_HEADER: 'My Profile',
  MY_PROFILE_SUBHEADER: 'Edit your profile',
  MY_PROFILE_BTN_TEXT: 'Save',
  MY_PROFILE_FORM_EMAIL_LABLE: 'Email',
  MY_PROFILE_FORM_FIRST_NAME_LABLE: 'First Name',
  MY_PROFILE_FORM_LAST_NAME_LABLE: 'Last Name',
  MY_PROFILE_FORM_FIRST_NAME_PLACEHOLDER: 'Enter your first name',
  MY_PROFILE_FORM_LAST_NAME_PLACEHOLDER: 'Enter your last name',
  MY_PROFILE_FORM_EMAIL_PLACEHOLDER: 'Enter your email',
  MY_PROFILE_FORM_EMAIL_HELP_TEXT: 'Need to change your email? Contact',
  MY_PROFILE_FORM_EMAIL_HELP_TEXT_LINK: 'support@simplifya.com',
  MY_PROFILE_FORM_COMPANY_PLACEHOLDER: 'Enter your company name',
  MY_PROFILE_FORM_COMPANY_LABLE: 'Company',
  MY_PROFILE_FORM_STATUS_LABEL: 'Status',
  MY_PROFILE_FORM_STATUS_PLACEHOLDER: 'Status',
  
  MY_PROFILE_FORM_TITLE_LABEL: 'Title',
  MY_PROFILE_FORM_TITLE_PLACEHOLDER: 'Enter your title',
  MY_PROFILE_FORM_TITLE_REQUIRED: 'Title is required',

  MY_PROFILE_FORM_PHONE_LABEL: 'Phone',
  MY_PROFILE_FORM_PHONE_PLACEHOLDER: 'Enter your Phone Number',
  MY_PROFILE_FORM_PHONE_REQUIRED: 'Phone Number is required',


  MY_PROFILE_SAVE_CHANGES_BTN: 'Update Details',
  PROFILE_SIDE_PANEL_TILE: 'Edit Profile',
  PROFILE_SIDEPANEL_TABS: {
    GENERAL: {
      TAB_TITLE: 'General',
      DESCRIPTION: 'Update your username and manage your account.',
      KEY: 'general'
    },
    PASSWORD: {
      TAB_TITLE: 'Password',
      DESCRIPTION: 'Manage your password.',
      KEY: 'password'
    },
    MANAGE_SUBSCRIPTIONS: {
      TAB_TITLE: 'Manage Subcriptions',
      DESCRIPTION: 'Effortlessly control and tailor your subcription preferences with our Subscription Management Feature.',
      KEY: 'manage_subscriptions'
    },
    USERS: {
      TAB_TITLE: 'Users',
      DESCRIPTION: 'Users List',
      KEY: 'users'
    }
  },
  PAYMENT_METHODS_TAB: {
    TITLE: 'Payment Methods',
    KEY: 'payment_methods',
  },
  VIEW_BILLING_HISTORY: {
    TITLE: 'View Billing History',
    KEY: 'view_billing_history',
  },
  USERS: {
    HEADERS: [
      { NAME: 'First Name', ID: 'first_name' },
      { NAME: 'Last Name', ID: 'last_name' },
      { NAME: 'Email', ID: 'email' },
    ],
  }, 
  BILLING_HISTORY_HEADERS: [
    { NAME: 'Transaction Id', key: 'transaction_id'},
    { NAME: 'Amount', key: 'transaction_id'},
    { NAME: 'Date & Time', key: 'transaction_id'},
    { NAME: 'Status', key: 'transaction_id'},
    // { NAME: 'icon', key: 'sort'}
  ],

  TAB_DESCRIPTION: {
    general: 'Update your username and manage your account', 
    password: 'Manage your password',
    manage_subscriptions: 'Effortlessly control and tailor your subscription preferences with our Subscription Management feature',
    users: 'Users List'
  },
  SUBSCRIPTION_PLAN: {
    month: 'Per Monthly',
    year: 'Per Yearly'
  },
  SUBSCRIPION_PLANS: {
    MONTHLY: 1,
    YEARLY: 2
  },
  SUBSCRIPTION_PLAN_TABS: {
    1: {TITLE: 'Monthly', KEY: 'monthly' },
    2: {TITLE: 'Yearly', KEY: 'yearly' }
  },
  SUBSCRIPTION_TYPES: {
    CANNABIS:1,
    HEMP: 2,
    ALL: 3, // both hemp and cannabis
  },
  SUBSCRIPTION_CARD:{
    DESC: {
      1: [
        'Full access to all states that have cannabis regulations',
        'Covers regulations from multiple agencies across cannabis-legal states',
        'Updated continuously to reflect the latest compillance changes',
        'Organized for easy access by state, topic and agency'
      ],
      2: [
        'Full access to all federal hemp regulations.',
        'Includes details ation processing, and distribution requirements',
        'Regular updates w/USDA and state-level changes',
        'Convers import/export rules, THC limits, testing, and more',
      ],
      3: [
        'Everything from cannabis Regs and Hemp Regs',
        'Unified platform to monitor both cannabis and hemp compliance requirements',
        'Access to all regulatory updates across all states with cannabis and hemp legislation'
      ]
    },
    MODAL: {
      TITLE: 'Subscription',
      AMOUNT_BANNER: {
        TITLE_1: 'Amount',
        TITLE_2: {
          MONTHLY: '(Monthly)',
          ANNUALLY: '(Annually)'
        },
        BODY: 'Full access to all states that have ',
        TYPE: {
          1: 'cannabis regulations',
          2: 'hemp regulations',
          3: 'cannabis and hemp regulations',
        },
        COUPON_CODE: 'Coupon Code',
        TOTAL: 'Total',
        AMOUNT_DUE: 'Amount due',
        APPLIED_BALANCE: 'Applied Balance',
        CARDS: 'Select a payment method'
      },
      FORM: {
        DESCRIPTION: {
          MONTHLY_PAYMENT_PLAN_TEXT:
            'By checking the box below, you agree to Simplifya’s Terms of Service. You understand that your credit card will automatically be charged on a monthly basis for the 12-month subscription to Simplifya RegFinder. Your annual subscription of RegFinder will auto-renew after 12 months unless you notify us at ',
          YEARLY_PAYMENT_PLAN_TEXT:
            'By checking the box below, you agree to Simplifya’s Terms of Service. You understand that your credit card will be charged now for the entire 12-month subscription to Simplifya RegFinder. Your annual subscription of RegFinder will auto-renew after 12 months unless you notify us at ',
          TEXT_1:
            'By checking the box below, you agree to Simplifya’s Terms of Service. You understand that your credit card will automatically be charged on a monthly basis for the 12-month subscription to Simplifya RegFinder by Simplifya (unless you opted to pay in full for the entire 12 month subscription).  Your annual subscription of RegFinder will auto-renew after 12 months unless you notify us at ',
          TEXT_2: ' 30-days prior to auto-renewal of your subscription.'
        },
        TERMS_CHECKBOX_TEXT: 'I have read & agree to the',
        CARD_VENDORS: ['visa', 'mastercard', 'amex', 'discover']
      },
      SUB_UPDATE_ERROR_MSG : 'An error occurred while updating your subscription.'
    }
  }
});
